import bootstrap from '@/js/bootstrap'

import {createApp} from "vue";

import App from '@/js/component/App.vue'
import * as Sentry from "@sentry/vue"

const run = () => {

    const app = createApp(App);

    Sentry.init({
        app,
        dsn: "https://f14e8831d4dfde614e8940314c1a8f30@o4509751290560512.ingest.de.sentry.io/4509887801917520",
        sendDefaultPii: true
    });

    // Bootstrap
    bootstrap(app);

    app.mount('#app');
};

run();
